import { createBrowserRouter } from "react-router-dom";

import { DashboardShell, dashboardLoader } from "./routes/_dashboard-shell";
import { PublicShell } from "./routes/_public-shell";
import { AppShell } from "./routes/_shell";
import AgentsRoute, { agentsLoader } from "./routes/agents";
import ApprovalsRoute from "./routes/approvals";
import ChannelsRoute from "./routes/channels";
import ChatRoute from "./routes/chat";
import EvaluationsRoute, { evaluationsLoader } from "./routes/evaluations";
import KnowledgeRoute, { knowledgeLoader } from "./routes/knowledge";
import LandingRoute, { landingLoader } from "./routes/landing";
import LlmRoute from "./routes/llm";
import LoginRoute, { loginLoader } from "./routes/login";
import MarketplaceRoute, { marketplaceLoader } from "./routes/marketplace";
import McpRoute, { mcpLoader } from "./routes/mcp";
import SettingsRoute, { settingsLoader } from "./routes/settings";
import SkillsRoute, { skillsLoader } from "./routes/skills";
import TeamsRoute, { teamsLoader } from "./routes/teams";
import WorkshopRoute, { workshopLoader } from "./routes/workshop";

/**
 * Router tree.
 *
 * Two top-level shells:
 *   - PublicShell  — marketing home + sign-in. ``state = null``.
 *   - DashboardShell — workspace chrome (sidebar + header). Gated on
 *     ``requireAuth`` via the dashboard loader; nested children get
 *     the active tenant via ``useAuth()``.
 *
 * Per-route loaders fan out the same fetches the old Next.js RSC
 * shells did, just from the browser. They pick up the
 * ``kos_session`` cookie automatically thanks to ``credentials:
 * include`` in ``lib/api``.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      {
        element: <PublicShell />,
        children: [
          {
            index: true,
            loader: ({ request }) => landingLoader({ request }),
            element: <LandingRoute />,
          },
          {
            path: "login",
            loader: ({ request }) => loginLoader({ request }),
            element: <LoginRoute />,
          },
        ],
      },
      {
        path: "/",
        element: <DashboardShell />,
        loader: dashboardLoader,
        children: [
          {
            path: "chat",
            element: <ChatRoute />,
          },
          {
            path: "agents",
            loader: agentsLoader,
            element: <AgentsRoute />,
          },
          {
            path: "approvals",
            element: <ApprovalsRoute />,
          },
          {
            path: "channels",
            element: <ChannelsRoute />,
          },
          {
            path: "evaluations",
            loader: evaluationsLoader,
            element: <EvaluationsRoute />,
          },
          {
            path: "knowledge",
            loader: knowledgeLoader,
            element: <KnowledgeRoute />,
          },
          {
            path: "llm",
            element: <LlmRoute />,
          },
          {
            path: "marketplace",
            loader: marketplaceLoader,
            element: <MarketplaceRoute />,
          },
          {
            path: "mcp",
            loader: mcpLoader,
            element: <McpRoute />,
          },
          {
            path: "settings",
            loader: settingsLoader,
            element: <SettingsRoute />,
          },
          {
            path: "skills",
            loader: skillsLoader,
            element: <SkillsRoute />,
          },
          {
            path: "teams",
            loader: teamsLoader,
            element: <TeamsRoute />,
          },
          {
            path: "workshop",
            loader: workshopLoader,
            element: <WorkshopRoute />,
          },
        ],
      },
    ],
  },
]);
